<template>
  <section class="new__wrapper">
    <h1 class="new__header">New Courses</h1>
    <div class="new__courses-wrapper">
      <CourseTile
        v-for="course in courses"
        :key="course.id"
        :course="course"
        :backgroundImg="course.images.small_image_url"
        :gradient="$getGradient()"
        :duration="course.duration || '0:00:00'"
        :link="$buildContentLink('course', course)"
        :customClass="'result-course'"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </div>
  </section>
</template>

<script>
import CourseTile from '@/components/layout/CourseTile.vue'

export default {
  name: 'New',
  components: {
    CourseTile,
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.new {
  &__header {
    color: var(--white);
    text-transform: capitalize;
  }
  &__wrapper {
    position: relative;
    padding: 150px 25px;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__courses-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
  }
  .result-course {
    width: 100%;
    padding: 5px;
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    @include lg-desktop {
      width: 15%;
    }
  }
}
</style>
